<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout wrap row>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <span style="color:#0cabc2">Select PO</span>
          </v-toolbar-title>
        </v-toolbar>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs2>
          <v-radio-group v-model="radios" :mandatory="false">
            <v-radio label="Auto invoice number" value="auto"></v-radio>
            <v-radio label="Manual invoice number" value="manual"></v-radio>
          </v-radio-group>
          <v-text-field
            v-if="radios=='manual'"
            solo
            prefix="#"
            type="number"
            placeholder="Invoice number"
            v-model="invoice_number"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs3>
          <v-autocomplete
            v-model="farmer"
            :items="farmerList"
            item-text="name"
            item-value="id"
            label="Farmer"
            @change="fetch_po()"
            persistent-hint
            small-chips
            solo
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="po_list_array"
            show-select
            item-key="id"
            select-all
            disable-initial-sort
            v-model="selected_po_to_invoice"
            :rows-per-page-items="[100, 150, 200, 250]"
            class="elevation-5"
          >
            <template slot="items" slot-scope="props">
              <tr :active="props.selected" @click="props.selected = !props.selected">
                <td>
                  <v-checkbox primary hide-details :input-value="props.selected"></v-checkbox>
                </td>
                <td class="text-xs">
                  <b>{{ props.item.date }}</b>
                </td>
                <td class="text-xs">
                  <b>{{ props.item.prefix_id }}</b>
                </td>

                <td class="text-xs">{{ props.item.driver_name }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <span style="color:#0cabc2">Adjust Price</span>
          </v-toolbar-title>
          <v-flex xs2>
            <v-text-field
              label="Total Sum(RM)"
              placeholder="0"
              v-model="total_price"
              outline
              disabled
            ></v-text-field>
          </v-flex>
        </v-toolbar>
        <v-layout>
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn  dark @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
                </v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="po_item_headers"
            :items="po_item"
            disable-initial-sort
            :rows-per-page-items="[100, 150, 200, 250]"
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <tr
                :style="{backgroundColor: (props.item.price == '0' ? '#ffffff' : props.item.price == '' ? '#ffffff': '#1976d21A' ) }"
              >
                <td class="text-xs-right">
                  <b>PO{{ props.item.po_id }}</b>
                </td>
                <td>
                  <v-avatar size="38">
                    <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
                  </v-avatar>
                </td>
                <td class="text-xs-right">{{ props.item.product_name }}</td>
                <td class="text-xs-right">{{ props.item.grade }}</td>
                <td class="text-xs-right">{{ props.item.location }}</td>
                <td class="text-xs-right">{{ props.item.weight_type }}</td>
                <td class="text-xs-right">{{ props.item.quantity }}</td>

                <td
                  class="text-xs-right"
                  :style="{color: (props.item.total_weight.includes('deducted') ? 'green'  : '#000000' ) }"
                >{{ props.item.total_weight }}</td>

                <td class="text-xs-right">
                  <v-btn
                    @click="getBalanceRecord(props.item.balance_detail,props.item.product_id,props.item.vege_stocked_date)"
                    :color="(props.item.balance_detail.includes('over') ? 'warning'  : 'primary' )"
                  >{{props.item.balance_detail}}</v-btn>
                </td>

                <td class="text-xs-right">
                  <v-text-field
                    v-model="props.item.price"
                    label="price"
                    type="number"
                    @focus="$event.target.select()"
                  ></v-text-field>
                </td>

                <td
                  class="text-xs-right"
                >{{ parseFloat(props.item.weight_after_deduction * props.item.price).toFixed(2) }}</td>
                <td class="justify-end layout px-5">
                  <v-icon medium color="warning" @click="editItem(props.item.id)">build</v-icon>
                  <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
     
                     <v-flex xs7></v-flex>
                      <v-flex xs2>
                          <v-btn  dark @click="bulkupdatePrice()" color="green">
                              Update All Price
                          </v-btn>

                      </v-flex>
        <v-flex xs2>
          <v-btn
            color="primary"
            :loading="saving"
            :disabled="saving"
            @click.native="create_invoice()"
          >Create</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog_edit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit item</span>
        </v-card-title>

        <v-card-text>
          <edit_dialog ref="edit" @update="fetch_po_item"></edit_dialog>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_balance_record">
      <v-card>
        <v-card-title>
          <span class="headline">Record</span>
        </v-card-title>

        <v-card-text>
          <balance_record ref="balance_record"></balance_record>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="5000">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import edit_dialog from "@/components/large_component/po_edit_dialog";
import moment from "moment";
import balance_record from "@/components/large_component/balance_price_detail";

import { debounce } from "lodash";

export default {
  components: {
    edit_dialog,
    balance_record
  },
  data: () => ({
    radios: "auto",
    baseUrl: baseUrl,
    dialog_balance_record: false,
    dialog_edit: false,
    headers: [
      { text: "Date", align: "", value: "date" },
      { text: "ID", align: "", value: "prefix_id" },
      { text: "Driver", align: "", value: "driver_name" }
    ],
    po_item_headers: [
      { text: "PO", align: "left", value: "po_id" },
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "left", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Locate", align: "right", value: "location" },
      { text: "KG", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "Total Kg/box", align: "right", value: "total_weight" },
      { text: "Balance PRICE", align: "right", value: "balance_detail" },
      { text: "$$perKG", align: "left", value: "price" },

      { text: "Amount", align: "right", value: "" },
      { text: "tools", align: "right", value: "id", sortable: false }
    ],
    po_list_array: [],
    farmerList: [],
    po_item: [],

    farmer: "",
    selected_po_to_invoice: [],
    total_price: "",
    saving: false,

    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response: "",
    response_detail: "",
    vege_adding_loading_value: "",
    invoice_number: ""
  }),

  watch: {
    selected_po_to_invoice: function(val) {
      //do something when the data changes.
      if (val) {
        this.fetch_po_item();
        this.totalPrice();
      }
    }
  },
  computed: {
    invoice_id() {
      if(this.radios=='auto'){
        return '';
      }else{
      return (this.invoice_number === null ? "" : this.invoice_number);
      }
    }
  },
  created() {
    this.getFarmer();
  },

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("Farmer List Problem" + response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    fetch_po: function() {
      const params = new URLSearchParams();
      params.append("getPurchaseOrderListForInvoice", "getDeliveryOrderList");
      params.append("farmer_id", this.farmer);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_list_array = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_list_array = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_po_item() {
      this.dialog_edit = false;
      this.po_item = [];
      const params = new URLSearchParams();
      params.append("fetch_po_item", "fetch_po_item");
      params.append("po_id", JSON.stringify(this.selected_po_to_invoice));

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_item = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_item = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },
    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deletePOStock", "deletePOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/purchase_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.fetch_po_item();
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    editItem(id) {
      this.dialog_edit = true;
      this.$refs.edit.fetch_item(id);
    },
    DebounceUpdatePrice: _.debounce(function(id, price) {
      this.updatePrice(id, price);
    }, 300),
    updatePrice(id, price) {
      const params = new URLSearchParams();
      params.append("updatePrice", "updatePrice");
      params.append("id", id);
      params.append("price", price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            // this.fetch_do_item();
            this.totalPrice();
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    bulkupdatePrice() {
      const params = new URLSearchParams();
      params.append("bulkupdatePrice", "bulkupdatePrice");
      // params.append("id", id);
      params.append("stock", JSON.stringify(this.po_item));
      // console.log(JSON.stringify(this.po_item))

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.fetch_po_item();
            this.totalPrice();
          } else if (response.data.error == true) {
            
            this.snackbar_response = true;
            this.response_detail = "Failed. Try reupdate";
            this.fetch_po_item();
            this.totalPrice();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    totalPrice() {
      const params = new URLSearchParams();
      params.append("total_price", "total_price");
      params.append("po_id", JSON.stringify(this.selected_po_to_invoice));
      console.log(JSON.stringify(this.selected_po_to_invoice));

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          console.log(response);
          if (response.data.error == false) {
            // this.fetch_do_item();
            this.total_price = response.data.TotalPrice;
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    create_invoice: function() {
      this.saving = true;
      const params = new URLSearchParams();
      params.append("createInvoice", "createInvoice");
      params.append("farmer_id", this.farmer);
      params.append("po_id", JSON.stringify(this.selected_po_to_invoice));
      params.append("invoice_id", this.invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.$emit("update", response.data.message);
            this.$emit("popup", response.data.message);
            this.po_list_array = [];
            this.po_item = [];
            this.total_price = "";
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.saving = false;
          } else if (response.data.error == true) {
                     this.$emit("update",  response.data.message);
            this.$emit("popup",  response.data.message);
            this.errors = response.data.message;
            this.saving = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.saving = false;

          this.snackbar = true;
        });
    },
    getBalanceRecord(balance_detail, product_id, vege_stocked_date) {
      console.log(product_id);
      console.log(vege_stocked_date);
      this.dialog_balance_record = true;
      this.$refs.balance_record.getrecord(
        balance_detail,
        vege_stocked_date,
        product_id
      );
    }
  }
};
</script>

